import type { ChipProps } from '@mui/material/Chip'

let statusColorMap: Record<string, ChipProps['color']> = {
  'Registration open': 'success',
  'Registration closed': 'info',
  Attended: 'success',
  Accepted: 'info',
  Waitlisted: 'warning',
  Pending: 'default',
  Declined: 'error',
}

let statusColor = (status: string): ChipProps['color'] =>
  statusColorMap[status] ?? 'default'

export default statusColor
